import $ from 'jquery'
import '../../website/js/simpleScroller'
import '../../website/js/jquery.scrollTo.min'
import loadTeasers from "./loadTeasers";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.curious')) {

        $('.curious .curious-scroller > ul').simpleScroller({ counter: true })

        const state = {
            page: 1
        };
        const teaserElement = document.querySelector('.teaser-container');
        const nextTeaserButton = document.querySelector('.next-teaser');

        const init = async function () {
            await loadTeasers('/blog/kuriositaeten', teaserElement, { type: 'teaser' })
        }
        await init()

        nextTeaserButton.addEventListener('click', async () => {
            if (await loadTeasers('/blog/kuriositaeten', teaserElement, {
                page: state.page + 1,
                type: 'teaser'
            })) {
                state.page++;
            }
        });

        teaserElement.addEventListener('click', async (event) => {
            const teaser = event.target;
            if (!(teaser instanceof HTMLElement)) {
                return;
            }

            const id = teaser.closest('.curious-teaser').dataset.id;

            const response = await fetch('/blog/kuriositaeten', {
                method: 'POST',
                body: JSON.stringify({
                    type: 'overlay',
                    id: id
                })
            })
            const overlay = await response.text();

            if (!overlay) return;

            document.body.insertAdjacentHTML('beforeend', overlay)

            $('.curious-overlay .curious-scroller > ul').simpleScroller({ counter: true })

            document.querySelector('.curious-overlay-close')
                .addEventListener('click', () => {
                document.querySelector('.curious-overlay').remove();
            })
        })

        window.addEventListener('keydown', () => {
            document.querySelector('.curious-overlay')?.remove();
        })
    }
})